module.exports = __webpack_public_path__ + "img/banner.b79b6242.jpg";